var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMana16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36.291 55.358)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6 0 0 6 1926.3 574.65)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -265,
    cy: -55.002,
    r: 50,
    fill: "#cac5c0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m242.15 54.586v305.03c0 36.282 15.096 54.42 45.222 54.42h7.674v20.682h-162.49v-20.682h10.734c30.654 0 46.008-18.138 46.008-54.42v-200.06c0-36.762-13.044-55.158-39.12-55.158h-16.092v-20.706h6.138c31.686 0 60.294-9.702 85.83-29.1h16.098zm120.35 164.75c28.104-26.532 56.448-39.858 85.08-39.858 30.654 0 55.416 12.294 74.346 36.81 17.37 22.476 26.04 49.83 26.04 82.008 0 34.746-10.218 65.154-30.654 91.194-22.476 29.13-50.58 43.686-84.294 43.686-39.858 0-72.036-17.37-96.588-52.104-21.456-30.654-32.19-66.936-32.19-108.85 0-44.94 12.258-86.226 36.81-123.79 24.504-37.548 57.48-64.242 98.862-80.088 22.98-8.706 47.532-13.044 73.572-13.044v19.932c-55.158 2.568-96.306 24.552-123.38 65.928-13.824 21.474-23.022 47.514-27.606 78.168zm-3.84 37.584c-0.49202 7.638-0.77403 15.318-0.77403 22.98 0 29.628 5.112 56.976 15.354 82.032 13.278 32.67 32.67 49.02 58.242 49.02 21.96 0 38.58-11.226 49.806-33.714 8.178-17.37 12.258-38.58 12.258-63.624 0-26.04-3.798-48.528-11.472-67.416-11.262-25.572-28.374-38.334-51.366-38.334-28.104 0-52.116 16.35-72.048 49.056z",
    fill: "#0d0f0f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMana16);
export default __webpack_public_path__ + "static/media/mana16.0037ad7b3f0a7e4176c0db48a5ca0489.svg";
export { ForwardRef as ReactComponent };